import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";
import { getVerificationStatusKeyAndFlag } from "../utils/getVerificationStatusKey";

export const useGetPrimaryContactVerificationStatus = (studentId, enabled) => {
    const {
        isLoading, data, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: [`student/${studentId}/contact/VerificationStatus`],
        queryFn: () => axiosManager.get$("/parent/api/contacts/VerificationStatus").then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        enabled: enabled && !!studentId,
    });

    // useQuery({
    //     queryKey: [`contracts/${studentId}`],
    //     queryFn: () => axiosManager.get$(`/parent/api/contracts/${studentId}`),
    //     enabled: !!studentId,
    // });

    // const docID = "3c8a775e-bafc-4dfb-8254-af1304b34185";
    // useQuery({
    //     queryKey: [`delete/contact/${contactId}/proof/${docID}`],
    //     queryFn: () => axiosManager.delete$(`/parent/api/contacts/${contactId}/ProofOfId/${docID}`),
    //     enabled: !!contactId,
    // });

    const primaryContactVerificationStatus = data || {};

    return {
        isLoading,
        isRefetching,
        primaryContactVerificationStatus,
        primaryContactVerificationKey: getVerificationStatusKeyAndFlag(primaryContactVerificationStatus, true),
        error,
        refetch,
    };
};
